/* istanbul ignore file */
import useProcessVariablesHelper from 'domain/gpo/cockpit/instance/Show/variables/processVariablesHelper';
import { Button } from 'framework/ui/mui-builder';
import Box from '@mui/material/Box';

interface Props {
  activeContext: string;
  setActiveContext: (context: string) => void;
}

const VariableContextPanel = ({ activeContext, setActiveContext }: Props) => {
  const { getVariableContexts } = useProcessVariablesHelper();
  const contexts = getVariableContexts();

  return (
    <Box sx={{ marginTop: '10px' }}>
      {contexts.map(context => (
        <Box component="span" key={context.executionId} sx={{ display: 'inline-block' }}>
          <Button
            onClick={() => setActiveContext(context.executionId)}
            sx={{ marginBottom: '-10px', marginTop: '5px', marginRight: '10px' }}
            size="small"
            variant={activeContext !== context.executionId ? 'outlined' : undefined}
          >
            {context.title}
          </Button>
        </Box>
      ))}
    </Box>
  );
};

export default VariableContextPanel;
